// extracted by mini-css-extract-plugin
export default {"sidebar":"styles-module__sidebar__src-labstep-web-components-Layout-Menu-TopBar-Breadcrumb-Mobile-_YerIR"};